import { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Title, BackButton } from '../../../../components/UI/ComponentsUI';
import { showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { getVision } from '../../../../services/auth';
import { VISIONS } from '../../../../utils/constants';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';
import { exportExcelToJson } from '../../../../utils/worksheetUtil';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const UploadContainer = (props) => {
    const [messageModal, setMessageModal] = useState({ message: "", open: false });
    const [selectedFile, setSelectedFile] = useState();
    const [showModal, setShowModal] = useState(false);
    const [messages, setMessages] = useState([]);
    const templateExF = [{
        "codforn": "",
        "nomeforn": "",
        "desenho": "",
        "denomina": "",
        "caixa": "",
        "qtd": "",
        "container": "",
        "tipocnt": "",
        "tipocarga": "",
        "bl": "",
        "nave": "",
        "tipotrp": "",
        "dtchegada": "",
    }];

    const templateExP = [{
        "Container": "", "Tipo Container": "", "Tamanho": "", "Placa/TC": "", "Unidade Medida Peso": "", "Peso Liquido": "", "Peso Bruto Total": "'", "Data Hora Chegada": "", "Fornecedor": "", "Linha": "",
        "Desenho": "", "Embalagem": "", "Pedido": "", "Etiqueta Pai": "", "Qtd Pai": "", "Etiqueta Filho": "", "Unidades por Caixa": "", "Sgr": "", "Lote": "", "Ordem de Compra": "", "Qtd Total": "", "Unidade Medida Peca": "",
        "Unidade Medida Qtd Total": "", "Data Chegada Porto": "", "Numero Documento": "", "Data Documento": "", "Porto de Origem": "",
    }];

    const sendFile = (save) => {
        if (selectedFile) {
            props.upload(selectedFile, showModal, save, (data) => {
                setShowModal(data.showModal);
                if (data.showModal) {
                    messageModal.message = data.messages[0];
                    setMessageModal({ ...messageModal })
                    openModal();
                }
                else {
                    setMessages(data.messages);
                    if (messageModal.open) {
                        messageModal.message = "";
                        messageModal.open = false;
                        setMessageModal({ ...messageModal })
                    }
                }

                if (data.messages.length === 0 && data.showModal === false) {
                    document.getElementById("fileInput").value = "";
                    setSelectedFile();
                    setShowModal(false);
                    showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');

                }
            });
        }
    }

    const exportExcel = () => {
        return exportExcelToJson(getVision() === VISIONS.PortoReal || getVision() === VISIONS.Palomar ? templateExP : templateExF, 'Template.xlsx')
    }

    const openModal = () => {
        messageModal.open = true;
        setMessageModal({ ...messageModal })
    }

    return (
        <>
            <div>
                <BackButton {...props} />
                <div className="container-fluid h-65">
                    <div className="row">
                        <Title icon="mdi mdi-clipboard-check-outline" label='Upload Container' />
                    </div>
                </div>
                <div className="title" style={{ float: 'right', margin: '10px' }}>
                    <label className="active" style={{ fontSize: '18px' }}>Template</label>
                    <i className="mdi mdi-24px mdi-arrow-down-circle" style={{ cursor: 'pointer' }} onClick={() => exportExcel()}></i>
                </div>
                <div className="container-fluid" style={{ marginTop: '25px', }}>
                    <div className="container">
                        <form action="#">
                            <div className="file-field input-field">
                                <div className="btn">
                                    <span>File</span>
                                    <input id="fileInput" required type="file" onChange={(event) => setSelectedFile(event.target.files[0])} />
                                </div>
                                <div className="file-path-wrapper">
                                    <input className="file-path validate" type="text" />
                                </div>
                            </div>
                        </form>
                        <div className="col s12 center" style={{ marginTop: '8px' }}>
                            <Button full="true" onClick={() => sendFile(false)} text="Enviar" />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
                            {messages.map((item) => (
                                <span key={item} className="fourth-text-color">
                                    {item}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
                <ConfirmModalUI
                    open={messageModal?.open}
                    id="messageModalConfirm"
                    data={{ title: translate('validations:attention'), message: messageModal?.message }}
                    onConfirm={() => {
                        sendFile(true);

                    }}
                    btnCancel={translate('cancel', 'general')}
                    btnConfirm={translate('confirm', 'general')}
                />
            </div>
        </>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        upload: (file, showModal, save, callback) => {
            dispatch(ContainerService.uploadContainer(file, showModal, save, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UploadContainer)));